import { AxiosInstance } from "axios";

import { generateApiUrlWithQueryParams } from "../utils/query-params";

export const basePath = "/login";

// All the paths for this api domain.
export const loginPaths = {
  getMagicLink: () => generateApiUrlWithQueryParams(`${basePath}/magic-link`),
};

class LoginApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  // Get magic link for login
  // GET /login/magic-link
  getMagicLink = (payload: any) => {
    return this.api.post(loginPaths.getMagicLink(), payload);
  };
}

export default LoginApi;
